import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Login',
      component: () => import('@/views/Login'),
      meta: {
        layout: 'Blank',
        requiresVisitor: true
      }
    },
    {
      path: '/zimmerübersicht',
      name: 'Zimmerübersicht',
      component: () => import('@/views/Rooms'),
      meta: {
        layout: 'TopNav',
        requiresAuth: true
      }
    },
    {
      path: '/pflegebericht/:id',
      name: 'Pflegebericht',
      component: () => import('@/views/Pflegebericht'),
      meta: {
        layout: 'Main',
        requiresAuth: true
      }
    },
    {
      path: '/leistungsnachweis',
      name: 'Leistungsnachweis',
      component: () => import('@/views/Leistungsnachweis'),
      meta: {
        layout: 'Main',
        requiresAuth: true
      }
    },
    {
      path: '/bedarfsmedikation',
      name: 'Bedarfsmedikation',
      component: () => import('@/views/Bedarfsmedikation'),
      meta: {
        layout: 'Main',
        requiresAuth: true
      }
    },
    {
      path: '/medikamentenblatt',
      name: 'Medikamentenblatt',
      component: () => import('@/views/Medikamentenblatt'),
      meta: {
        layout: 'Main',
        requiresAuth: true
      }
    },
    {
      path: '/schmerzkurve',
      name: 'Schmerzkurve',
      component: () => import('@/views/Schmerzkurve'),
      meta: {
        layout: 'Main',
        requiresAuth: true
      }
    },
    {
      path: '/wunderhebung',
      name: 'Wunderhebung',
      component: () => import('@/views/Wunderhebung'),
      meta: {
        layout: 'Main',
        requiresAuth: true
      }
    },
    {
      path: '/mobilisationsprotokoll',
      name: 'Mobilisationsprotokoll',
      component: () => import('@/views/Mobilisationsprotokoll'),
      meta: {
        layout: 'Main',
        requiresAuth: true
      }
    },
    {
      path: '/settings',
      name: 'Settings',
      component: () => import('@/views/Settings'),
      meta: {
        layout: 'Blank',
        requiresAuth: true
      }
    },
  ]
})
